<template>
  <div id="tableHERO" class="TableListItem tableHERO">
    <ul class="LeftSideNav">
      <template v-for="(one, b_index) in hero" :key="b_index">
        <li @click="cur_key = b_index" :class="{ current: cur_key == b_index }">
          {{ one['name'] }}
        </li>
      </template>
    </ul>

    <div class="TableBox clear">
      <div class="TableContentshero">
        <ul class="TopSideNav clear">
          <li :class="{ current: cur_key2 == 0 }" @click="cur_key2 = 0">
            基本信息
          </li>
          <li :class="{ current: cur_key2 == 1 }" @click="cur_key2 = 1">
            技能
          </li>
          <li :class="{ current: cur_key2 == 2 }" @click="cur_key2 = 2">
            装备
          </li>
        </ul>
        <div class="TableBox-box">
          <!-- 基础 -->
          <basic v-if="cur_key2 == 0" :one="one_hero" />
          <!-- 神通start -->
          <skill v-if="cur_key2 == 1" :one="one_hero" />
          <!-- 化神start -->
          <equ v-if="cur_key2 == 2" :one="one_hero" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';

import basic from './hero_c/basic.vue';
import skill from './hero_c/skill.vue';
import equ from './hero_c/equ.vue';

const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({}),
  },
});

const cur_key = ref(0);
const cur_key2 = ref(0);

const hero = computed(() => {
  return props.role_data?.hero || {};
});

const one_hero = computed(() => {
  return hero.value[cur_key.value] || {};
});
</script>
